import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackJustifyContent, StackType, StackWidth, TabTypeTokens, WIDGET, } from '@voltmoney/schema';
import { appendURlWithParam, isMobile, setAppHeader } from '../../configs/utils';
import { ACTION } from "../partnerWeb_Dashboard/types";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { downloadClick, onCategorySelect, onChangeTab, onFilterSelect, openMenu, presentationMaterialDownload, promoBannerInvite } from "./action";
import { BottomNavBuilderDS } from "../bottomNav";
import { GoToFaq, GoToHome, GoToPhone } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress } from "../partnerWeb_Dashboard/actions";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { partnerApi, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { navigateByUrl, ShowNewRmContactButton } from "../partnerWeb_Dashboard/utils";
import SharedPropsService from "../../SharedPropsService";
const _isMobile = isMobile();
export const template = async (collateralData, customCollateralList, presentationMaterial, languagesSelected, height, selectedCollateralCategory, showNewRmContactButton, rmData, selectedCollateralCategoryName, isFromMobile) => ({
    layout: {
        id: ROUTE.COLLATERAL,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            { id: 'collateralMainStack', type: WIDGET.STACK },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ]
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.COLLATERAL,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.COLLATERAL),
        ...await SideBarBuilderDS(ROUTE.COLLATERAL),
        ...await BottomNavBuilderDS(ROUTE.COLLATERAL),
        collateralMainStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : {}
            },
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "collateralHeading", type: WIDGET.TEXT },
                { id: "space2", type: WIDGET.SPACE },
                { id: "collateralDescription", type: WIDGET.TEXT },
                { id: "space32", type: WIDGET.SPACE },
                { id: "tabb", type: WIDGET.TABS }
            ]
        },
        tabb: {
            active: 0,
            type: TabTypeTokens.DEFAULT,
            customWidth: _isMobile ? 360 : 552,
            options: [
                {
                    label: "Co-branded banner",
                    disabled: false
                },
                {
                    label: "Presentation materials",
                    disabled: false
                },
            ],
            doNotNeedScroll: !isMobile(),
            widgetItems: [
                {
                    id: "coBrandedStack", type: WIDGET.STACK,
                },
                {
                    id: "presentationMaterialContainerStack", type: WIDGET.PRESENTATION_MATERIAL_SCREEN,
                },
            ]
        },
        addContactDetails: {
            width: StackWidth.FULL,
            type: StackType.row,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR3,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                }
            },
            bgColor: ColorTokens.Grey_Chalk,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                all: SizeTypeTokens.XXXL
            },
            widgetItems: [
                { id: "collateralHeading", type: WIDGET.TEXT },
                { id: "addContactDetailsIcon", type: WIDGET.IMAGE }
            ]
        },
        addContactDetailsIcon: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/add_contact_details.png',
            width: 221,
            height: 120
        },
        coBrandedStack: {
            type: StackType.column,
            widgetItems: [
                { id: "collateralContainerStack", type: WIDGET.COLLATERAL_INTRO_SCREEN }
            ],
        },
        collateralContainerStack: {
            customCollateralFullData: customCollateralList,
            downloadAction: {
                type: ACTION.DOWNLOAD_CLICK,
                routeId: ROUTE.COLLATERAL,
            },
            isMobile: _isMobile,
            languageFilterAction: {
                type: ACTION.FILTER_LANGUAGE_SELECT,
                routeId: ROUTE.COLLATERAL,
            },
            languagesSelected: languagesSelected,
            counter: Math.random(),
            height: height,
            setCategoryAction: {
                type: ACTION.ON_CATEGORY_SELECT,
                routeId: ROUTE.COLLATERAL,
                payload: {}
            },
            selectedCollateralCategory: selectedCollateralCategory,
            selectedCollateralCategoryName: selectedCollateralCategoryName
        },
        presentationMaterialStack: {
            type: StackType.column,
            widgetItems: [
                { id: "collateralDescription", type: WIDGET.TEXT }
            ]
        },
        presentationMaterialContainerStack: {
            presentationMaterial: presentationMaterial,
            downloadAction: {
                type: ACTION.PRESENATATION_MATERIAL_DOWNLOAD,
                routeId: ROUTE.COLLATERAL,
                payload: {}
            },
            loading: false,
            height: height
        },
        spaceXXXL: {
            size: SizeTypeTokens.XXXL
        },
        space30: {
            size: SizeTypeTokens.Size30
        },
        space32: {
            size: SizeTypeTokens.Size32
        },
        space2: {
            size: SizeTypeTokens.XS
        },
        collateralHeading: {
            label: 'Collaterals',
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins
        },
        collateralDescription: {
            label: 'Create and share co-branded collateral with clients',
            fontSize: FontSizeTokens.SM,
            fontWeight: '400',
            lineHeight: 20,
            color: ColorTokens.Grey_Charcoal,
            fontFamily: FontFamilyTokens.Inter
        },
    },
});
export const collateralNav = {
    onLoad: async ({ network, instrumentTrack, asyncStorage, openNewTab, setDatastore, navigate, getHeight, ...props }, { collateralCategory }) => {
        instrumentTrack("COLLATERAL_PAGE_VIEWED");
        appendURlWithParam('collateral');
        await setAppHeader();
        const languagesSelected = await SharedPropsService.getFilteredList();
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        if (!accessToken) {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab);
            return;
        }
        const sharedPropCollateralsData = await SharedPropsService.getCollateralsData();
        const sharedPropPresentationMaterialData = await SharedPropsService.getPresentationMaterialData();
        let collateralsData;
        let presentationMaterialData;
        const isFromMobile = isMobile();
        if (sharedPropCollateralsData.length === 0) {
            const getCustomerCollateralListData = await network.get(`${partnerApi.getCustomCollateralList}`, {
                headers: await getAppHeader(),
            });
            collateralsData = getCustomerCollateralListData?.data;
            await SharedPropsService.setCollateralsData(getCustomerCollateralListData?.data);
        }
        else {
            collateralsData = sharedPropCollateralsData;
        }
        const collateralResponse = await network.get("https://api.staging.voltmoney.in/util/web/static/data?pageId=collateral", {});
        if (sharedPropPresentationMaterialData.length === 0) {
            const getPresentationMaterialList = await network.get(`${partnerApi.getPresentationMaterialList}`, {
                headers: await getAppHeader(),
            });
            presentationMaterialData = getPresentationMaterialList?.data;
            await SharedPropsService.setPresentationMaterialData(getPresentationMaterialList?.data);
        }
        else {
            presentationMaterialData = sharedPropPresentationMaterialData;
        }
        const selectedCollateralCategory = await SharedPropsService.getSelectedCollateralCategory();
        const selectedCollateralCategoryName = await SharedPropsService.getSelectedCollateralCategoryName();
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const user = await AsyncStorage.getItem("user_context");
        const userData = await JSON.parse(user);
        const partnerAccountId = userData?.linkedPartnerAccounts[0].accountId;
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        return Promise.resolve(template(collateralResponse.data.data, collateralsData, presentationMaterialData, languagesSelected, getHeight(), selectedCollateralCategory, showNewRmContactButton, rmData, selectedCollateralCategoryName, isFromMobile));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: promoBannerInvite,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.DOWNLOAD_CLICK]: downloadClick,
        [ACTION.PRESENATATION_MATERIAL_DOWNLOAD]: presentationMaterialDownload,
        [ACTION.FILTER_LANGUAGE_SELECT]: onFilterSelect,
        [ACTION.ON_CATEGORY_SELECT]: onCategorySelect,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    },
};
